module.exports = __webpack_public_path__ + "img/guitarra.f9f42955.jpg";